/* eslint-disable @typescript-eslint/no-unsafe-call */
/* eslint-disable @typescript-eslint/no-unsafe-member-access */
/* eslint-disable @typescript-eslint/no-unsafe-assignment */
/* eslint-disable @typescript-eslint/no-unsafe-argument */
/* eslint-disable @typescript-eslint/no-explicit-any */
import { Component, OnInit, viewChild, ChangeDetectionStrategy } from '@angular/core';
import { ToastService, ToastType } from '../../shared/toast/toast.service';
import { CurrentUserService } from '../../user/services';
import { GenericModalService, ModalMultiButton, ModalSettingsConfirmMultiButton } from '../../shared/generic-modal/generic-modal.service';
import { LoadingPanelService } from '../../shared/loading-panel/loading-panel.service';
import { ArtifactAssemblyTypes, AssemblyArtifact } from '../../developer/models/artifact';
import { DeveloperArtifactService } from '../../developer/services/developer-artifact.service';
import { DeveloperService } from '../../developer/services/developer.service';
import { FormatType } from '../../developer/models/format-type';
import { DataFieldGroup } from '../../shared/datafields/models';
import { UntypedFormGroup, FormsModule } from '@angular/forms';
import { DocumentTypeDeveloper, LightTrackingOptions } from '../../developer/models/document-type';
import { PartnerService } from '../../partner/services/partner.service';
import { Partner } from '../../partner/models/partner';
import { DocumentConfigSearchDisplay } from '../../distribution/models/document-config-search';
import { DocumentConfigSearch, DocumentConfigService } from '../../distribution/services';
import { Direction } from '../../distribution/models/direction';
import { DxDataGridComponent, DxDataGridTypes } from 'devextreme-angular/ui/data-grid';
import { Format } from '../../developer/models/format';
import { GridService } from '../../shared/grid/grid.service';
import { CompareRule } from '../models/test-tool-compare-rule';
import { TestToolService } from '../services/test-tool.service';
import { SvgIconComponent } from '../../shared/icons/svg-icon.component';
import { PermissionRequiredDirective } from '../../shared/authentication/permission-required.directive';
import { ChangeLogLinkComponent } from '../../shared/change-log/change-log-link/change-log-link.component';
import { ChangeLogLinkEntityDirective } from '../../shared/change-log/change-log-link-entity/change-log-link-entity.directive';

import { DxDataGridModule, DxDropDownBoxModule } from 'devextreme-angular';
import { BizDataGridDirective } from '../../shared/grid/biz-grid.directive';
import { DxoRowDraggingModule, DxoSortingModule, DxoEditingModule, DxoFormModule, DxiItemModule, DxoColumnFixingModule, DxiColumnModule, DxiValidationRuleModule, DxoLookupModule, DxiButtonModule, DxoPagingModule, DxoScrollingModule, DxoSelectionModule } from 'devextreme-angular/ui/nested';
import { BizUserColumnDirective } from '../../shared/grid/biz-grid-user.directive';
import { BizDateColumnDirective } from '../../shared/grid/biz-grid-date.directive';
import { DxTemplateModule } from 'devextreme-angular/core';
import { DeveloperArtifactAssemblyPickerComponent } from '../../developer/developer-artifacts/developer-artifact-assembly-picker.component';
import { DataFieldGroupContainerComponent } from '../../shared/datafields/datafield-group-container.component';
import { PartnerSelectorComponent } from '../../partner/partner-selector.component';
import { BizGridFiltervalues } from 'src/app/shared/grid/biz-grid-filtervalues';
import { TestToolExportService } from '../services/test-tool-export.service';

@Component({
    selector: 'app-test-tool-compare-rules',
    templateUrl: './test-tool-compare-rules.component.html',
    styleUrls: ['./test-tool-compare-rules.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [SvgIconComponent, PermissionRequiredDirective, ChangeLogLinkComponent, ChangeLogLinkEntityDirective, DxDataGridModule, BizDataGridDirective, DxoRowDraggingModule, DxoSortingModule, DxoEditingModule, DxoFormModule, DxiItemModule, DxoColumnFixingModule, DxiColumnModule, DxiValidationRuleModule, DxoLookupModule, BizUserColumnDirective, BizDateColumnDirective, DxiButtonModule, DxTemplateModule, DeveloperArtifactAssemblyPickerComponent, DataFieldGroupContainerComponent, PartnerSelectorComponent, FormsModule, DxDropDownBoxModule, DxoPagingModule, DxoScrollingModule, DxoSelectionModule]
})
export class TestToolCompareRulesComponent implements OnInit {
    hasCompareRuleCreatePerm = false;
    hasCompareRuleEditPerm = false;
    hasCompareRuleDeletePerm = false;
    hasCompareRuleShowLogPerm = false;

    compareRules: CompareRule[] = [];
    partnersUsed: Partner[] = [];
    artifacts: AssemblyArtifact[] = [];
    formats: Format[] = [];
    formatTypes: FormatType[] = [];
    currentCompareRule: CompareRule | null;
    allDocType: DocumentTypeDeveloper = {
        Id: -1 ,
        Name: 'All',
        Description: 'All document types',
        FilenamingTypes: [],
        LightTrackingOptions: new LightTrackingOptions(),
        UsableForDistributions: false,
        CdmStylesheetArtifactId: null,
        DocumentTypeGroupId: null,
        CdmEmbeddedFileDataXPath: null,
        CdmEmbeddedFileNameXPath: null,
        CreatedBy: null,
        CreatedDate: null,
        UpdatedBy: null,
        UpdatedDate: null
    };
    docTypes: DocumentTypeDeveloper[] = [];
    documentConfigs_In: DocumentConfigSearchDisplay[] = [];
    documentConfigsToDisplay_In: DocumentConfigSearchDisplay[] = [];
    selectedDocumentConfig_In: number | null;
    documentConfigs_Out: DocumentConfigSearchDisplay[] = [];
    documentConfigsToDisplay_Out: DocumentConfigSearchDisplay[] = [];
    selectedDocumentConfig_Out: number | null;
    selectedDocumentType: number = -1;

    orderEditMode = false;

    compareRuleDisplayGroups: DataFieldGroup[] = [];
    compareRuleFormGroup: UntypedFormGroup = new UntypedFormGroup({});

    compareRulessGrid = viewChild.required<DxDataGridComponent>('compareRulessGrid');

    constructor(
        public bizGridFiltervalues: BizGridFiltervalues,
        private developerService: DeveloperService,
        private testToolService: TestToolService,
        private testToolExportService: TestToolExportService,
        private toastService: ToastService,
        private currentUserService: CurrentUserService,
        private modalService: GenericModalService,
        private loadingPanelService: LoadingPanelService,
        private developerArtifactService: DeveloperArtifactService,
        private partnerService: PartnerService,
        private documentConfigService: DocumentConfigService,
        private gridService: GridService) {

        this.cloneCompare = this.cloneCompare.bind(this);
        this.allowUpdatingRow = this.allowUpdatingRow.bind(this);
        this.allowDeletingRow = this.allowDeletingRow.bind(this);
        this.allowShowLog = this.allowShowLog.bind(this);
        this.displayExprArtifact = this.displayExprArtifact.bind(this);
        this.displayExprPartner = this.displayExprPartner.bind(this);
    }

    ngOnInit(): void {
        this.hasCompareRuleCreatePerm = this.currentUserService.hasPermission('TestTool_Action_TestCase_Create');
        this.hasCompareRuleEditPerm = this.currentUserService.hasPermission('TestTool_Action_TestCase_Edit');
        this.hasCompareRuleDeletePerm = this.currentUserService.hasPermission('TestTool_Action_TestCase_Delete');
        this.hasCompareRuleShowLogPerm = this.currentUserService.hasPermission('Developer_Action_ShowLog');
        void this.initAsync();
    }

    async initAsync(): Promise<void> {
        const [artifacts, formats, documentConfigs_In, documentConfigs_Out, formatTypes, doctypes] = await Promise.all([
            this.developerArtifactService.getAssemblyArtifacts(true, [ArtifactAssemblyTypes.TypeComparePlugin]),
            this.developerService.getFormats(),
            this.documentConfigService.getDocumentConfigs(new DocumentConfigSearch(Direction.In)),
            this.documentConfigService.getDocumentConfigs(new DocumentConfigSearch(Direction.Out)),
            this.developerService.getFormatTypes(),
            this.developerService.getDocumentTypes()
        ]);
        this.artifacts = artifacts;
        this.formats = formats.sort((f1, f2) => f1.FormatName.localeCompare(f2.FormatName));
        this.documentConfigs_In = documentConfigs_In.sort((dc1, dc2) => (dc1.FormatName + dc1.VariantName + dc1.VersionName).localeCompare((dc2.FormatName + dc2.VariantName + dc2.VersionName)));
        this.documentConfigs_Out = documentConfigs_Out.sort((dc1, dc2) => (dc1.FormatName + dc1.VariantName + dc1.VersionName).localeCompare((dc2.FormatName + dc2.VariantName + dc2.VersionName)));

        this.formatTypes = formatTypes.sort((ft1, ft2) => ft1.Name.localeCompare(ft2.Name));

        doctypes.sort((dt1, dt2) => dt1.Name.localeCompare(dt2.Name));
        this.docTypes = [this.allDocType, ...doctypes];

        this.selectedDocumentConfig_In = null;
        this.selectedDocumentConfig_Out = null;
        await this.refresh();
    }

    sortWithAllItem(value1: string, value2: string) {
        if (value1 === 'All')
            return -1;
        if (value2 === 'All')
            return 1;

        return value1.localeCompare(value2);
    }

    async cloneCompare(e: any) {
        const originalCompareRule = e.row.data as CompareRule;
        try {
            await this.modalService.confirmDirect('Copy', 'Create a copy of ' + originalCompareRule.Name + '?');
            const clonedCompareRule = await this.testToolService.cloneCompareRule(originalCompareRule.Id);
            await this.refresh();
            this.toastService.showToast(clonedCompareRule.Name + ' created successfully', ToastType.success);
        } catch {
            // Ignore cancel
        };
    }

    allowUpdatingRow(options: { component: any; row: any; }): boolean {
        const item: CompareRule = options?.row?.data;
        if (item) {
            return this.hasCompareRuleEditPerm;
        }
        return false;
    }

    allowDeletingRow(options: { component: any; row: any; }): boolean {
        const item: CompareRule = options?.row?.data;
        if (item) {
            return this.hasCompareRuleDeletePerm;
        }
        return false;
    }

    allowShowLog(options: { component: any; row: any; }): boolean {
        const item: CompareRule = options?.row?.data;
        if (item) {
            return this.hasCompareRuleShowLogPerm;
        }
        return false;
    }

    displayExprArtifact(e: any) {
        if (this.artifacts) {
            const artifact = this.artifacts.find(a => a.ArtifactId === e.value);
            if (artifact) {
                return `${artifact.Name} [${artifact.Filename}]`;
            }
        }
        return 'Unknown...';
    }

    displayExprPartner(e: any) {
        if (this.partnersUsed) {
            const partner = this.partnersUsed.find(a => a.PartnersId === e.value);
            if (partner) {
                return `${partner.PartnerName}`;
            }
        }
        return '';
    }

    getDocumentTypeName(compareRule: CompareRule) {
        return this.docTypes.find(d => d.Id === compareRule.DocumentTypesId)?.Name || 'Unknown';
    }

    onInitNewRow = (e: any): void => {
        this.currentCompareRule = {
            Id: null,
            Name: '',
            Description: '',
            ArtifactId: '',
            FormatTypesId: null,
            PluginConfiguration: '',
            DocumentTypesId: -1,
            DocumentConfigsId_In: null,
            PartnersId_In: null,
            DocumentConfigsId_Out: null,
            PartnersId_Out: null,
            SortOrder: this.getNextSortOrder()
        } as CompareRule;
        this.selectedDocumentConfig_In = null;
        this.selectedDocumentConfig_Out = null;

        e.data = this.currentCompareRule;
    };

    onEditOrderClick() {
        this.orderEditMode = true;
        this.compareRulessGrid().instance.option('selection', { mode: 'none' });
    }

    async onSaveOrderClick(): Promise<void> {
        this.loadingPanelService.showLoadingPanelDirect('Saving...');
        try {
            const updates = this.compareRules
                .map((compareRule, index) => ({ compareRule, newSortOrder: 10 * (index + 1) }))
                .filter(({ compareRule, newSortOrder }) => compareRule.SortOrder !== newSortOrder)
                .map(({ compareRule, newSortOrder }) => {
                    compareRule.SortOrder = newSortOrder;
                    return this.testToolService.saveCompareRule(compareRule, null);
                });
            await Promise.all(updates);

            this.orderEditMode = false;
            this.compareRulessGrid().instance.option('selection', { mode: 'multiple' });
        } finally {
            this.loadingPanelService.hideLoadingPanel();
        }
    };

    onCancelOrderEditClick() {
        this.compareRules = this.sortCompareRules(this.compareRules);
        this.orderEditMode = false;
        this.compareRulessGrid().instance.option('selection', { mode: 'multiple' });
    }

    onReorder = (e: Parameters<DxDataGridTypes.RowDragging['onReorder']>[0]) => {
        e.promise = this.onReorderAsync(e);
    };

    async onReorderAsync(e: Parameters<DxDataGridTypes.RowDragging['onReorder']>[0]) {
        const fromIndex = e.fromIndex;
        const toIndex = e.toIndex;
        const workingArray = this.compareRules.slice();

        this.moveItem(workingArray, fromIndex, toIndex);
        this.compareRules = workingArray;

        await e.component.refresh();
    }

    moveItem<T>(array: T[], indexFrom: number, indexTo: number): T[] {
        // Check if indexFrom and indexTo are within the bounds of the array
        if (indexFrom < 0 || indexFrom >= array.length || indexTo < 0 || indexTo >= array.length) {
            throw new Error('Index out of bounds');
        }

        // Remove the item at indexFrom and store it in a variable
        const item = array.splice(indexFrom, 1)[0];

        // Insert the item at indexTo
        array.splice(indexTo, 0, item);

        return array;
    }

    async refresh() {
        this.loadingPanelService.showLoadingPanelDirect('Loading compare plugins...');
        this.selectedDocumentConfig_In = null;
        this.selectedDocumentConfig_Out = null;
        this.currentCompareRule = null;
        this.compareRuleDisplayGroups = [];
        const compareRules = this.sortCompareRules(await this.testToolService.getCompareRule());

        // Getting partners used
        const partnerIds: number[] = [];
        compareRules.forEach(compareRule => {
            if (compareRule.PartnersId_In !== null) {
                partnerIds.push(compareRule.PartnersId_In);
            }
            if (compareRule.PartnersId_Out !== null) {
                partnerIds.push(compareRule.PartnersId_Out);
            }
        });
        if (partnerIds.length > 0) {
            this.partnersUsed = await this.partnerService.getLightPartners(partnerIds);
            this.compareRules = compareRules;
        }
        else {
            this.compareRules = compareRules;
        }
        this.loadingPanelService.hideLoadingPanel();
    }

    sortCompareRules(compareRules: CompareRule[]): CompareRule[] {
        return compareRules.sort((x, y) => x.SortOrder - y.SortOrder);
    }

    getNextSortOrder(): number {
        return 1 + Math.max(...this.compareRules.map(e => e.SortOrder), -1);
    }

    onRowValidating = (ev: any): void => {
        this.compareRuleFormGroup.updateValueAndValidity();
        if (this.compareRuleFormGroup.invalid) {
            ev.isValid = false;
            ev.errorText = 'Ensure that all required fields are completed and all fields contain valid values.';
            void this.modalService.messageDirect('Validation error', ev.errorText);
        }
    };

    onRowInserting = (e: any): void => {
        e.cancel = this.gridService.handleDataGridRow(e.data as CompareRule, item => this.saveCompareRule(item));
    };

    onRowUpdating = (e: any): void => {
        e.cancel = this.gridService.handleDataGridRow({ ...e.key, ...e.newData } as CompareRule, item => this.saveCompareRule(item), e.newData);
    };

    onRowRemoving = (e: any): void => {
        e.cancel = this.gridService.handleDataGridRow(e.data as CompareRule, item => this.deleteCompareRule(item));
    };

    async deleteCompareRule(compareRule: CompareRule): Promise<CompareRule> {
        try {
            await this.testToolService.deleteCompareRule(compareRule.Id, err => err?.status !== 409);
            this.toastService.showToast('Compare rule deleted...', ToastType.success);
        }
        catch (err) {
            // Process 409 error here; other errors are processed using generic error handling
            if (err?.status === 409) {
                const settings = new ModalSettingsConfirmMultiButton('Delete failed', `Error details: <pre style='white-space: pre-wrap;'>${err.error}</pre>`);
                settings.size = 'lg';
                settings.backdrop = 'static';
                settings.buttons = [new ModalMultiButton('Close', null, 'btn btn-primary')];
                await this.modalService.confirmMultiButton(settings);
            }
        }
        await this.refresh();
        return compareRule;
    }

    async saveCompareRule(compareRule: CompareRule): Promise<CompareRule> {
        try {
            if (compareRule.DocumentTypesId !== null && compareRule.DocumentTypesId < 1) {
                compareRule.DocumentTypesId = null;
            }
            if (compareRule.FormatTypesId !== null && compareRule.FormatTypesId < 1) {
                compareRule.FormatTypesId = null;
            }
            const datafieldValues = DataFieldGroup.getDataFieldValues(this.compareRuleDisplayGroups, false);
            const savedCompareRule = await this.testToolService.saveCompareRule(compareRule, datafieldValues);
            this.toastService.showToast('Compare rule saved...', ToastType.success);
            return savedCompareRule;
        }
        catch (err) {
            console.error(err);
            this.toastService.showToast('Failed to save compare rule...', ToastType.error);
            return undefined;
        }
        finally {
            await this.refresh();
        }
    }

    getPartner(cellInfo: any) {
        if (this.partnersUsed) {
            const partner = this.partnersUsed.find(a => a.PartnersId === cellInfo.value);
            if (partner) {
                return partner;
            }
            else {
                return null;
            }
        }
        return null;
    }

    async setArtifactId(artifactId: string, cellInfo: any) {
        if (artifactId.length > 0 && artifactId !== cellInfo.value && this.currentCompareRule?.Id === null) {
            cellInfo.setValue(artifactId || '');
            this.compareRuleDisplayGroups = await this.testToolService.getCompareRuleDataFieldGroups(artifactId);
        }
        else if (artifactId.length > 0 && artifactId !== cellInfo.value && this.currentCompareRule?.Id !== null) {
            cellInfo.setValue(artifactId || '');
            this.compareRuleDisplayGroups = await this.testToolService.getCompareRuleDataFieldGroups(artifactId, this.currentCompareRule.Id);
        }
        else {
            cellInfo.setValue(artifactId || '');
        }
    }

    updatePartnersUsed(partner: Partner) {
        const partnerinternal = this.partnersUsed.find(a => a.PartnersId === partner.PartnersId);
        if (!partnerinternal) {
            if (partner !== null) {
                this.partnersUsed.push(partner);
            }
        }
    }

    setPartnerToId(partner: Partner, cellInfo: any) {
        if (partner) {
            this.updatePartnersUsed(partner);
            cellInfo.setValue(partner.PartnersId);
        }
        else {
            cellInfo.setValue(null);
        }
    }

    setPartnerFromId(partner: Partner, cellInfo: any) {
        if (partner) {
            this.updatePartnersUsed(partner);
            cellInfo.setValue(partner.PartnersId);
        }
        else {
            cellInfo.setValue(null);
            this.selectedDocumentConfig_Out = null;
        }
    }
    setDocTypeValue(this: DxDataGridTypes.Column, newData: CompareRule, value: number, currentRowData: CompareRule) {
        newData.DocumentConfigsId_In = null;
        newData.DocumentConfigsId_Out = null;
        currentRowData.DocumentConfigsId_In = null;
        currentRowData.DocumentConfigsId_Out = null;
        this.defaultSetCellValue(newData, value, currentRowData);
    }


    setFormatTypeId(formatTypeId: string, cellInfo: any) {
        cellInfo.setValue(formatTypeId || '');
    }

    getDocumentConfigName_In(compareRule: CompareRule): string {
        const documentConfig = this.documentConfigs_In.filter(x => x.DocumentConfigId === compareRule.DocumentConfigsId_In)[0];
        if (documentConfig) {
            return `${documentConfig.FormatName} / ${documentConfig.VariantName} / ${documentConfig.VersionName}`;
        } else {
            return '';
        }
    }

    getDocumentConfigName_Out(compareRule: CompareRule): string {
        const documentConfig = this.documentConfigs_Out.filter(x => x.DocumentConfigId === compareRule.DocumentConfigsId_Out)[0];
        if (documentConfig) {
            return `${documentConfig.FormatName} / ${documentConfig.VariantName} / ${documentConfig.VersionName}`;
        } else {
            return '';
        }
    }

    customizeItem(item: any) {
        if (item.dataField === 'IsSystemItineraryStep') { // Hide the 'Download' column when editing...
            item.visible = false;
        }
    }

    onFormatTypeSelectionChanged(selectedRowKeys, cellInfo, dropDownBoxComponent): void {
        if (selectedRowKeys.length > 0) {
            cellInfo.setValue(selectedRowKeys[0]);
            dropDownBoxComponent.close();
            const newFormatId = selectedRowKeys[0];
            this.selectedDocumentConfig_Out = null;

            if (newFormatId > 0 && this.selectedDocumentType > 0) {
                this.documentConfigsToDisplay_Out = this.filterDocConfigOnFormatType(this.documentConfigs_Out.filter(x => x.DistributionObjectId === this.selectedDocumentType), newFormatId);
            }
            else if (newFormatId < 1 && this.selectedDocumentType > 0) {
                this.documentConfigsToDisplay_Out = this.documentConfigs_Out.filter(x => x.DistributionObjectId === this.selectedDocumentType);
            }
            else {
                this.documentConfigsToDisplay_Out = [];
            }
            this.currentCompareRule.FormatTypesId = newFormatId;
        }
    }

    onDocTypeSelectionChanged(selectedRowKeys, cellInfo, dropDownBoxComponent): void {
        cellInfo.setValue(selectedRowKeys[0]);
        if (selectedRowKeys.length > 0) {
            dropDownBoxComponent.close();
        }
        if (selectedRowKeys[0] === null || selectedRowKeys[0] < 1) {
            this.selectedDocumentConfig_In = null;
            this.selectedDocumentConfig_Out = null;
            this.documentConfigsToDisplay_In = [];
            this.documentConfigsToDisplay_Out = [];
            this.selectedDocumentType = -1;
        }
        else if (selectedRowKeys[0] !== null && selectedRowKeys[0] > 0) {
            this.selectedDocumentConfig_In = null;
            this.selectedDocumentConfig_Out = null;
            this.documentConfigsToDisplay_In = this.documentConfigs_In.filter(x => x.DistributionObjectId === selectedRowKeys[0]);
            if (this.currentCompareRule.FormatTypesId !== null && this.currentCompareRule.FormatTypesId > 0) {
                this.documentConfigsToDisplay_Out = this.filterDocConfigOnFormatType(this.documentConfigs_Out.filter(x => x.DistributionObjectId === selectedRowKeys[0]), this.currentCompareRule.FormatTypesId);
            }
            else {
                this.documentConfigsToDisplay_Out = this.documentConfigs_Out.filter(x => x.DistributionObjectId === selectedRowKeys[0]);
            }
            this.selectedDocumentType = selectedRowKeys[0];
        }
    }

    onDocConfigOutValueChanged(id: any, cellInfo: any) {
        this.selectedDocumentConfig_Out = id;
        cellInfo.setValue(id);
    }

    onDocConfigInValueChanged(id: any, cellInfo: any) {
        this.selectedDocumentConfig_In = id;
        cellInfo.setValue(id);
    }

    async onEditingStart(e: any) {
        const compareRule = e.data as CompareRule;

        if (compareRule.DocumentTypesId !== null && compareRule.DocumentTypesId > 0) {
            this.selectedDocumentType = compareRule.DocumentTypesId;
            this.selectedDocumentConfig_In = compareRule.DocumentConfigsId_In;
            this.selectedDocumentConfig_Out = compareRule.DocumentConfigsId_Out;
            this.documentConfigsToDisplay_In = this.documentConfigs_In.filter(x => x.DistributionObjectId === compareRule.DocumentTypesId);
            if (compareRule.FormatTypesId > 0) {
                this.documentConfigsToDisplay_Out = this.filterDocConfigOnFormatType(this.documentConfigs_Out.filter(x => x.DistributionObjectId === compareRule.DocumentTypesId), compareRule.FormatTypesId);
            }
            else {
                this.documentConfigsToDisplay_Out = this.documentConfigs_Out.filter(x => x.DistributionObjectId === compareRule.DocumentTypesId);
            }
        }
        else if (compareRule.DocumentTypesId === null || compareRule.DocumentTypesId < 1) {
            this.selectedDocumentType = -1;
            this.selectedDocumentConfig_In = null;
            this.selectedDocumentConfig_Out = null;
            this.documentConfigsToDisplay_In = [];
            this.documentConfigsToDisplay_Out = [];
            compareRule.DocumentTypesId = -1;
        }

        if (compareRule.FormatTypesId === null) {
            compareRule.FormatTypesId = -1;
        }

        this.currentCompareRule = compareRule;
        this.compareRuleDisplayGroups = await this.testToolService.getCompareRuleDataFieldGroups(compareRule.ArtifactId, compareRule.Id);
        e.component.cellValue(e.component.getRowIndexByKey(e.key), 'Name', e.component.cellValue(e.component.getRowIndexByKey(e.key), 'Name'));
        // Lidt hacky, men for at vi kan få de dynamiske datafield-værdier med i en save, hvor man ikke har ændret andet end disse værdier, så trigger vi en ændring her, så update altid bliver kaldt.
    }

    filterDocConfigOnFormatType(docConfigs: DocumentConfigSearchDisplay[], formatTypeId: number) {
        const returnDocConfigs: DocumentConfigSearchDisplay[] = [];
        docConfigs.forEach(config => {
            const format = this.formats.filter(x => x.FormatsId === config.FormatId);
            if (format[0].FormatTypesId === formatTypeId) {
                returnDocConfigs.push(config);
            }
        });
        return returnDocConfigs;
    }

    async onEditCanceled(_ev: any) {
        this.currentCompareRule = null;
        this.compareRuleDisplayGroups = [];
        await this.refresh();
    }

    disableEditOrderButton(): boolean {
        return !this.hasCompareRuleEditPerm || this.orderEditMode;
    }

    get canExportCompareRules(): boolean {
        return this.compareRules && !!this.compareRulessGrid().selectedRowKeys.length;
    }

    exportCompareRules(): void {
        if (this.canExportCompareRules) {
            const ids = this.compareRulessGrid().selectedRowKeys.map((e: CompareRule) => e.Id);
            void this.testToolExportService.exportCompareRules(ids);
        }
    }
}
